import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données du trigger de 'Date atteinte'.
 */
export class FolderCreatedTriggerData extends BaseTriggerData {
    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.FolderCreated);
    }

    /**
     * Retourne une copie d'une instance de FolderCreatedTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: FolderCreatedTriggerData) {
        if (!!other) {
            const instance = new FolderCreatedTriggerData();
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
